/**
 * Listino — schemi per il tariffario prezzi servizio (F-009.4).
 *
 * Un prezzo (cents) per ciascun tipo di pratica (`PraticaTipologia`), gestito
 * dall'ADMIN. Usato al submit per addebitare il wallet dell'agente.
 *
 * Boundary HTTP: i prezzi BigInt sono serializzati come stringhe (come il resto
 * dei campi monetari del codebase). L'input admin è in euro (number), convertito
 * a cents server-side via `euroToCents`.
 */
import { z } from 'zod';
/**
 * Valori di `PraticaTipologia` (mirror dell'enum Prisma — tenere in sync).
 * Esportato così frontend e validazioni condividono l'elenco canonico.
 */
export const PRATICA_TIPOLOGIE = [
    'REGISTRAZIONE',
    'PROROGA',
    'RISOLUZIONE',
    'CESSIONE',
    'CEDOLARE',
    'RAVVEDIMENTO',
];
export const praticaTipologiaSchema = z.enum(PRATICA_TIPOLOGIE);
/** Etichette italiane per la UI (admin listino + storico). */
export const PRATICA_TIPOLOGIA_LABEL = {
    REGISTRAZIONE: 'Registrazione',
    PROROGA: 'Proroga',
    RISOLUZIONE: 'Risoluzione',
    CESSIONE: 'Cessione',
    CEDOLARE: 'Cedolare secca',
    RAVVEDIMENTO: 'Ravvedimento',
};
/** Singola voce del listino (response, prezzi cents come stringa). */
export const listinoItemSchema = z.object({
    tipologia: praticaTipologiaSchema,
    /** Prezzo agenti/commercialisti (addebito wallet). */
    prezzoCents: z.string(),
    /** Prezzo privati (pay-per-practice Stripe, F-010). */
    prezzoPrivatiCents: z.string(),
    updatedAt: z.string().nullable(),
});
/** Risposta del listino completo (sempre 6 voci, una per tipologia). */
export const listinoResponseSchema = z.object({
    items: z.array(listinoItemSchema),
});
/**
 * Input PATCH admin per impostare i prezzi di una tipologia. Importi in euro
 * (la UI lavora in euro); il server converte a cents. Range 0–100.000 €.
 * `prezzoEuro` = agenti, `prezzoPrivatiEuro` = privati (F-010): entrambi
 * opzionali ma almeno uno richiesto.
 */
const prezzoEuroField = z
    .number()
    .nonnegative({ message: 'Il prezzo non può essere negativo' })
    .max(100000, { message: 'Prezzo troppo alto' });
export const updateTariffaInputSchema = z
    .object({
    tipologia: praticaTipologiaSchema,
    prezzoEuro: prezzoEuroField.optional(),
    prezzoPrivatiEuro: prezzoEuroField.optional(),
})
    .refine((v) => v.prezzoEuro !== undefined || v.prezzoPrivatiEuro !== undefined, {
    message: 'Specificare almeno un prezzo (agenti o privati)',
    path: ['prezzoEuro'],
});
//# sourceMappingURL=listino.js.map